import React, { Component } from 'react'
import PropTypes from 'prop-types'
import TextEditor from './TextEditor'

class NoteElement extends Component {
  noteContent = null

  constructor(props) {
    super(props)
    this.state = {
      editing: false,
      preview: true,
    }
  }

  render() {
    const {
      noteTitle,
      url,
      value,
      onChange,
      onBlur,
      paramName,
      blockEdit,
      ...props
    } = this.props

    const { editing, preview } = this.state

    return (
      <div className='noteElement' {...props}>
        <h1>{noteTitle.title}</h1>
        {noteTitle.subTitle && <h2>{noteTitle.subTitle}</h2>}
        {!blockEdit && (
          <div
            className='editIcon'
            onClick={() => {
              this.noteContent = null
              this.setState({
                editing: !editing,
                preview: editing,
              })
            }}
          >
            {editing ? 'Save' : 'Edit'}
          </div>
        )}
        <div
          className={'noteContent' + (preview ? ' preview' : '')}
          style={{
            height:
              this.noteContent &&
              this.noteContent.getBoundingClientRect().height,
          }}
        >
          <TextEditor
            minimal={!editing}
            paramName={paramName}
            url={url}
            defaultValue={value}
            onChange={onChange}
            onBlur={onBlur}
            readOnly={!editing}
            refs={(ref) => !this.noteContent && (this.noteContent = ref)}
          />
        </div>
        {this.noteContent &&
          this.noteContent.getBoundingClientRect().height > 48 && (
            <>
              {preview ? (
                <p
                  className='showMore'
                  onClick={() => this.setState({ preview: false })}
                >
                  Show More
                </p>
              ) : (
                !editing && (
                  <p
                    className='showMore'
                    onClick={() => this.setState({ preview: true })}
                  >
                    Hide
                  </p>
                )
              )}
            </>
          )}
      </div>
    )
  }
}

export default NoteElement

NoteElement.propTypes = {
  noteTitle: PropTypes.shape({
    title: PropTypes.string.isRequired,
    subTitle: PropTypes.string,
  }).isRequired,
  url: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
}
